const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPavootLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 870 870",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M207.33,429.64l-44.43-16.16-32.29-4.49c.36.87.72,1.74,1.09,2.61,4.9,11.56,10.36,22.88,16.33,33.93l77.82,13.73-18.51-29.62Z",
    style: {
      fill: "#24bdbb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.73,541.63l-33.51-48.69-40.16-78.44-25.58-51.78c-.24.11-.49.21-.73.31l19.58,66.62,18.51,29.62-77.82-13.73c18.93,35.06,43.01,67.37,71,95.84l29.55-3.43,39.16,3.68Z",
    style: {
      fill: "#05a5bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.73,541.63l-39.16-3.68-29.55,3.43c28.7,29.19,61.51,54.35,97.08,74.29,6.85-2.03,12.75-5,18.85-8.25l13.21-7.04,2.39-1.4-38.79-26.65-24.04-30.7Z",
    style: {
      fill: "#00829a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.79,501.8l-12.06,39.82,24.04,30.7,38.79,26.65,16.88-9.91,10.88-6.39c-25.19-25.96-48.63-56.5-68.67-89.54l-9.87,8.66Z",
    style: {
      fill: "#05a5bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.22,492.94l33.51,48.69,12.06-39.82,9.87-8.66c-26.17-43.17-46.52-90.62-57.3-137.74l-38.29,59.1,40.16,78.44Z",
    style: {
      fill: "#24bdbb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.88,291.6c6.52,10.07,8.8,22.56,7.51,34.48-.66,6.08-2.24,12.12-4.89,17.62-1.45,3.01-3.22,5.86-5.33,8.46-3.66,4.51-8.39,8.21-13.69,10.55l25.58,51.78,38.29-59.1c-.75-3.26-1.45-6.52-2.11-9.77-4.82-24.02-7.16-48.93-17.29-71.24-3.95-8.71-9.47-17.04-16.18-24.01l-21.03,30.46c3.18,2.75,6.25,6.3,9.13,10.75Z",
    style: {
      fill: "#7fc998"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.33,429.64l-19.58-66.62c-3.13,1.29-6.43,2.12-9.82,2.34-9.46.63-18.93-3.41-25.78-9.97-4.77-4.56-8.33-10.24-10.75-16.4l-13.68,1.13-14.56,9.03c3.07,20.45,9.49,40.69,17.44,59.83l32.29,4.49,44.43,16.16Z",
    style: {
      fill: "#7fc998"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.4,339c-1.06-2.69-1.91-5.48-2.54-8.3-8-35.61,28.72-74.26,56.89-49.86l21.03-30.46c-10.47-10.88-23.86-18.44-38.79-18.88-15.27-.45-30.18,6.73-40.92,17.59-10.74,10.86-17.58,25.11-21.49,39.87-5.23,19.7-5.44,40.05-2.42,60.2l14.56-9.03,13.68-1.13Z",
    style: {
      fill: "#d9ef7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.46,514.12l-36.85-90.23-9.23-99.56-.66-119.26c-.2-.04-.39-.08-.59-.12l-10.06,71.72,1.03,69.6,5.49,49.71-53.45-29.06c15.35,48.56,37.59,95.17,64.84,138.21h17.76l21.73,8.98Z",
    style: {
      fill: "#05a5bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.1,346.27l-1.03-69.6,10.06-71.72c-9.36-1.88-17.82-7.3-23.67-15.57-13.02-18.39-11.35-43.76.07-62.89l-15.94-8.22-27.75,9.15c-8.3,22.9-11.59,47.58-12.73,72.02-1.55,33.32.76,66.59,6.4,99.36l32.02,15.59,32.57,31.89Z",
    style: {
      fill: "#7fc998"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.1,346.27l-32.57-31.89-32.02-15.59c3.96,23.02,9.56,45.78,16.63,68.13l53.45,29.06-5.49-49.71Z",
    style: {
      fill: "#24bdbb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.89,118.53c18.73,29.17,2.61,75.07-30.78,85.4-6.19,1.92-12.46,2.23-18.39,1.14l.66,119.26,65.09-73.34c8.46-30.21,21.28-58.77,29.27-89.18,5.08-19.36,6.81-40.77,2.03-59.9l-48.66,15.44c.27.39.53.77.79,1.17Z",
    style: {
      fill: "#7fc998"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.53,126.5c1.8-3.02,3.84-5.89,6.11-8.55,10.81-12.64,26.82-20.29,43.64-16.46,9.5,2.16,17.35,7.93,22.82,15.88l48.66-15.44c-2.63-10.52-7.22-20.35-14.32-28.77-19.16-22.7-53.37-29.31-81.52-19.82-28.15,9.49-50.17,32.84-63.03,59.62-2.27,4.73-4.28,9.56-6.06,14.48l27.75-9.15,15.94,8.22Z",
    style: {
      fill: "#d9ef7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.62,423.89l36.85,90.23,5.67-34.96,11.54-4.41c-7.8-33.4-11.9-67.69-12.43-101.87-.55-35.54,2.77-71.19,10.26-105.94,1.16-5.38,2.5-10.68,3.97-15.94l-65.09,73.34,9.23,99.56Z",
    style: {
      fill: "#24bdbb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.46,514.12l-21.73-8.98h-17.76c1.29,2.04,2.59,4.08,3.91,6.1,23.19,35.73,49.55,68.16,84.35,92.94,2.57-.53,5.03-.87,7.57-1.83l2.11-.8-31.99-35.94-26.45-51.49Z",
    style: {
      fill: "#00829a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.31,589.93c-2.09-3.66-4.11-7.36-6.08-11.08-17.34-32.81-30.12-67.93-38.56-104.1l-11.54,4.41-5.67,34.96,26.45,51.49,31.99,35.94,7.41-2.82c.2-.08.54-.82.38-1.09l-4.39-7.7Z",
    style: {
      fill: "#05a5bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.13,204.96c.2.04.39.08.59.12",
    style: {
      fill: "#00829a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.2,162.36c-3.22,18.81-14.94,35.43-31.66,44.7-15.33,8.5-32.94,8.42-46.03,0l-33.44,48.53,67.92-3.82,40.4,11.19c21.54-24.67,40.26-50.96,49.51-82.13,6.01-20.25,7.51-42.26,1.73-62.49l-50.14,18.93c2.67,7.91,3.18,16.6,1.72,25.1Z",
    style: {
      fill: "#7fc998"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.2,206.16c-5.58-3.93-10.25-9.43-13.45-16.52-5.9-13.09-5.22-28.57.12-41.84.66-1.65,1.4-3.27,2.19-4.85l-24.04-13.29-36.01,6.09s-.01.02-.02.03l20.01,123.6,51.21-53.23Z",
    style: {
      fill: "#24bdbb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.36,417.35l8.39-90.81,28.23-67.15-20.01-123.6c-5.05,8.77-9.63,17.83-13.88,26.98-4.02,8.64-7.76,17.41-11.22,26.29-21.86,56.07-32.58,116.34-32.16,176.51l22.32,18.98,18.31,32.81Z",
    style: {
      fill: "#7fc998"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.6,459.32l.76-41.97-18.31-32.81-22.32-18.98c.09,13.14.7,26.27,1.86,39.35.11,1.2.23,2.41.34,3.61l16.31,9.59,21.37,41.21Z",
    style: {
      fill: "#24bdbb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.16,415.94l-9.17-6.99-30.52,9.92,3.82-34.34,12.97-58.76,32.81-70.2,33.44-48.53c-.44-.29-.88-.58-1.31-.89l-51.21,53.23-28.23,67.15-11.17,85.63,2.01,47.15,5.34,69.44,17.03,58.19c3.89-2.26,8.32-4.83,8.32-4.83.78-.45.97-1.08.65-1.9-19.45-55.34-9.18-112.63,15.22-164.27Z",
    style: {
      fill: "#05a5bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.06,142.95c4.91-9.85,12.17-18.32,21.37-24.52,9.08-6.12,19.53-9.61,30.46-9.11,9.06.41,17.53,3.57,24.3,9.45,5.88,5.11,9.93,11.49,12.29,18.48l50.14-18.93c-.51-1.78-1.07-3.56-1.69-5.31-10.19-28.65-36.44-50.96-66.36-56.41-31.7-5.77-64.78,6.82-89.33,27.7-16.85,14.33-30.16,32.2-41.24,51.45l36.01-6.09,24.04,13.29Z",
    style: {
      fill: "#d9ef7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.6,459.32l-21.37-41.21-16.31-9.59c3.37,35.27,10.61,70.18,21.74,103.82,2.15,6.51,29.1,79.95,32.58,77.94,0,0,2.7-1.57,5.73-3.33l-17.03-58.19-5.34-69.44Z",
    style: {
      fill: "#00829a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.07,255.57l-32.81,70.2-12.97,58.76-3.82,34.34,30.52-9.92,9.17,6.99c16.28-34.45,38.84-66.39,63.08-93.54,17.81-19.95,37.43-39.16,55.14-59.46l-40.4-11.19-67.92,3.82Z",
    style: {
      fill: "#24bdbb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.99,498.07l-64.5,9.28-24.69,81.8c1.41.75,2.82,1.49,4.24,2.22,8.84,4.54,17.47,8.73,26.6,12.76,13.06,5.77,26.49,10.18,40.74,12.28,44.33-44.51,78.44-103.01,81.96-166.82.08-1.45.14-2.91.2-4.37l-27.32,2.23-37.22,50.62Z",
    style: {
      fill: "#00829a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.26,509.24l-37.22,8.93-37.52-15.63c-1.03,10.94-1.12,21.86-.38,32.94.85,12.68,2.8,24.96,6.57,37.18l10.78-6.52c6.82-4.13,11.95-8.78,18.96-12.39l19.92,14.97c10.32,7.76,21.1,14.4,32.43,20.44l30.6-79.27-44.13-.64Z",
    style: {
      fill: "#00829a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.9,295.65c-15.4-1.67-26.8,15.23-20.26,28.91,0,0-26.24,26.16-26.24,26.16-3.89-3.76-7.84-7-12.24-10.44l34.54-53.62c19.32,4.12,32.43-20.42,18.16-34.16-6.39-6.15-17.05-7.27-24.58-2.58-10.01,6.24-12.31,20.49-5.07,29.62,0,0-34.27,53.17-34.27,53.17-4.98-2.78-10.04-4.91-15.6-6.26l10.16-30.37c25.02-1.73,23.73-39.8-.81-40.2-19.16-.31-26.87,25.14-12.21,36.4,0,0-10.26,30.78-10.26,30.78-16.25-1.92-31.07.8-44.6,6.61l-9.36,25.47,20.82,6.94c1.62-.9,3.48-1.41,5.46-1.41,6.24,0,11.29,5.06,11.29,11.29s-5.06,11.29-11.29,11.29c-.56,0-1.1-.05-1.64-.13l50.9,21.93,17.22,4.21-7.16-40.73,30.02-6.82c-.37-.5-.65-.72-.8-.57,9.03-9,18.47-17.83,27.06-27.18,11.76,5.31,26.78-2.72,28.5-15.7,1.4-10.58-7.14-21.46-17.75-22.61Z",
    style: {
      fill: "#7fc998"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.62,329.66c-26.23,11.26-47.6,34.13-65.03,57.31,0,.01-7.72,10.26-7.72,10.26l.28-.02,63.11-42.07,9.36-25.47Z",
    style: {
      fill: "#d9ef7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.03,409.27l-17.22-4.21-4.8,42.98-41.62,9.71c-2.49,4.33-5.91,8.16-10.62,11.95-3.86,3.1-7.5,6.17-11.71,8.79-8.47,5.26-16.96,8.8-26.57,11.7-25.28,7.63-60.22,9.44-85.45.17-.65,4.07-1.15,8.12-1.54,12.18l19.48,22.39,69.03-6.62,53.14,12.91,45.9-32.99,27.15-50.79,27.32-2.23c.59-15.34-.22-31.19-3.62-46.11-.74-3.27-12.57-32.76-16.01-37.39l-30.02,6.82,7.16,40.73Z",
    style: {
      fill: "#05a5bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.03,409.27l-68.12-26.14c-5.46-.79-9.66-5.48-9.66-11.16,0-4.26,2.36-7.96,5.83-9.88l-20.82-6.94-63.11,42.07,14.56-1.17c14.27-1.15,36.02,1.86,49.94,7.44,9.65,3.87,16.35,6.9,24.05,14.14,3.75,3.52,6.32,7.61,8.13,12.43,1.34,3.58,1.35,7.29.8,11.15-.92,6.55-2.53,11.86-5.23,16.56l41.62-9.71,22.01-38.77Z",
    style: {
      fill: "#24bdbb"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "254.8 675.54 324.15 613.31 400.61 687.99 519.74 602.64 701.11 723.55",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M227.29,691.09c0,19.22-7.29,33.6-21.88,43.12-14.59,9.53-34.19,14.29-58.81,14.29-3.12,0-5.82-.08-8.09-.25,0,18.38.67,40.59,2.02,66.65h-24.28c1.26-23.94,1.9-52.78,1.9-86.5,0-29-.63-55.05-1.9-78.16h18.08c1.94,0,7.48-.12,16.63-.38,9.15-.25,16.92-.38,23.33-.38,16.19,0,29.07,3.69,38.64,11.06,9.57,7.38,14.35,17.56,14.35,30.54ZM206.17,698.42c0-21.67-14.8-32.5-44.39-32.5-7.25,0-15.39.63-24.41,1.9.59,13.74.89,35.16.89,64.24,2.95.17,6.58.25,10.88.25,38.02,0,57.04-11.3,57.04-33.89Z",
    style: {
      fill: "#00829a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.92,814.89l-19.85.76c-1.01-4.13-1.52-8.05-1.52-11.76h-1.26c-10.37,9.44-24.49,14.16-42.37,14.16-9.7,0-18.04-2.85-25.04-8.54-7-5.69-10.5-13.8-10.5-24.34,0-12.98,5.48-23.42,16.44-31.3,10.96-7.88,31.32-12.03,61.08-12.46.25-2.02.38-4.34.38-6.96,0-10.37-2.76-17.28-8.28-20.74-5.52-3.46-13.89-5.19-25.1-5.19-13.24,0-26.26,1.64-39.08,4.93l2.15-17.45c12.65-3.62,27.19-5.44,43.63-5.44,15,0,26.6,3.1,34.78,9.29,8.18,6.2,12.27,16.76,12.27,31.68,0,3.96-.19,11.15-.57,21.56-.38,10.41-.57,17.35-.57,20.8,0,15.35,1.14,29,3.41,40.97ZM306.53,790.36c-.42-12.81-.63-24.32-.63-34.52-15.85,0-27.91,1.18-36.17,3.54-13.83,4.22-20.74,12.27-20.74,24.15s8.09,17.2,24.28,17.2c13.91,0,25-3.46,33.26-10.37Z",
    style: {
      fill: "#00829a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.83,694.75c0,4.13-8.54,24.05-25.61,59.76-17.07,35.71-25.61,55.83-25.61,60.39h-16.95c0-5.9-7.53-26.54-22.57-61.9-15.05-35.37-22.57-54.78-22.57-58.24h24.53c0,4.05,5.48,20.11,16.44,48.18,10.96,28.08,16.44,44.14,16.44,48.18h1.14c0-3.88,5.21-19.35,15.62-46.41,10.41-27.06,15.62-43.71,15.62-49.96h23.52Z",
    style: {
      fill: "#00829a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.17,751.16c0,21.58-6.2,38.43-18.59,50.52-12.39,12.1-26.98,18.15-43.76,18.15-15.68,0-29.15-5.35-40.41-16.06-11.26-10.71-16.88-25.8-16.88-45.28,0-21.75,6.22-38.74,18.65-50.96,12.43-12.22,27.04-18.34,43.82-18.34,15.68,0,29.13,5.42,40.34,16.25,11.21,10.83,16.82,26.07,16.82,45.72ZM542.29,755.58c0-13.15-3.31-24.85-9.93-35.09-6.62-10.24-16.04-15.37-28.26-15.37s-21.48,4.85-28.01,14.54c-6.54,9.7-9.8,20.95-9.8,33.77s3.31,24.96,9.93,35.16c6.62,10.2,16.08,15.3,28.39,15.3s21.46-4.87,27.95-14.61c6.49-9.74,9.74-20.97,9.74-33.7Z",
    style: {
      fill: "#00829a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.45,751.16c0,21.58-6.2,38.43-18.59,50.52-12.39,12.1-26.98,18.15-43.76,18.15-15.68,0-29.15-5.35-40.41-16.06-11.26-10.71-16.88-25.8-16.88-45.28,0-21.75,6.22-38.74,18.65-50.96,12.43-12.22,27.04-18.34,43.82-18.34,15.68,0,29.13,5.42,40.34,16.25,11.21,10.83,16.82,26.07,16.82,45.72ZM668.57,755.58c0-13.15-3.31-24.85-9.93-35.09-6.62-10.24-16.04-15.37-28.26-15.37s-21.48,4.85-28.01,14.54c-6.54,9.7-9.8,20.95-9.8,33.77s3.31,24.96,9.93,35.16c6.62,10.2,16.08,15.3,28.39,15.3s21.46-4.87,27.95-14.61c6.49-9.74,9.74-20.97,9.74-33.7Z",
    style: {
      fill: "#00829a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.58,797.44l-1.52,16.44c-6.66,2.44-12.94,3.67-18.84,3.67-15.18,0-25.54-3.86-31.11-11.57s-8.35-21.52-8.35-41.42c0-12.9.08-29.72.25-50.46-4.72,0-11.68.25-20.87.76l.76-18.34c8.01.51,15.18.76,21.5.76,0-5.06.42-17.07,1.26-36.04l19.85-2.02c-1.43,17.71-2.15,30.39-2.15,38.06,8.26,0,20.4-.42,36.42-1.26l-.89,18.84c-15.18-.51-27.36-.76-36.55-.76-.17,12.73-.25,27.06-.25,43,0,17.37,1.83,28.86,5.5,34.46,3.67,5.61,10.47,8.41,20.42,8.41,3.29,0,8.13-.84,14.54-2.53Z",
    style: {
      fill: "#00829a"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPavootLogo);
export default __webpack_public_path__ + "static/media/pavoot-logo.7ee0ecb699c6b9a8af49da125d7454fa.svg";
export { ForwardRef as ReactComponent };